module.exports = __webpack_public_path__ + "static/media/homepagekettlebell.ddd74121.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/homepagekettlebell.png
// module id = 550
// module chunks = 0